import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: ${em(20)} 1fr;
  column-gap: ${em(10)};
  align-items: start;
  opacity: ${p => p.theme.blocks.blockMutedOpacity};
  width: 100%;
  text-align: left;

  p {
    width: 100%;
    max-width: 100%;
    margin: 0;
    font-size: ${em(16)};
    line-height: ${em(20, 16)};
    text-align: left;
  }

  p br {
    content: '';
    display: block;
    margin-top: ${em(10)};
  }

  ${p => p.theme.mq.upMd} {
    display: flex;
    align-items: flex-start;
    max-width: none;
    padding-top: 0;
    text-align: left;

    p {
      width: auto;
      max-width: none;
      font-size: inherit;
      line-height: inherit;
    }

    p br {
      content: normal;
      display: inline;
      margin-top: 0;
    }
  }
`

export const IconWrapper = styled.div`
  width: ${em(20)};
  height: ${em(20)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: ${em(1)};

  svg,
  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  ${p => p.theme.mq.upMd} {
    width: ${p => p.theme.blocks.iconDisclaimerW};
    height: ${p => p.theme.blocks.iconDisclaimerH};
    margin-top: 0;
    margin-right: ${em(18)};
    margin-bottom: 0;
  }
`
